import { render, staticRenderFns } from "./UserNotificationDetail.vue?vue&type=template&id=4e4633f4&scoped=true"
import script from "./UserNotificationDetail.vue?vue&type=script&lang=js"
export * from "./UserNotificationDetail.vue?vue&type=script&lang=js"
import style0 from "./UserNotificationDetail.vue?vue&type=style&index=0&id=4e4633f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4633f4",
  null
  
)

export default component.exports